import { render, staticRenderFns } from "./completed.vue?vue&type=template&id=07f5c9e4&scoped=true&"
import script from "./completed.vue?vue&type=script&lang=js&"
export * from "./completed.vue?vue&type=script&lang=js&"
import style0 from "./completed.vue?vue&type=style&index=0&id=07f5c9e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f5c9e4",
  null
  
)

export default component.exports